import WaitlistPop from './WaitlistPop'

export default WaitlistPop
